import styled from 'foundations-theming/utils';
const BannersContainer = styled.div.withConfig({
  displayName: "BannersContainer",
  componentId: "japrbu-0"
})(["> *{margin-bottom:16px;}"]);
export default BannersContainer;